import './Tabs.css';
export var tabsArrowButtonCSS = '_1tfbrxp6-3-15-1';
export var tabsArrowWrapperCSS = '_1tfbrxp5-3-15-1';
export var tabsCSS = '_1tfbrxp0-3-15-1';
export var tabsWrapperCSS = '_1tfbrxp1-3-15-1';
export var tabsWrapperOverflowCSS = {left:'_1tfbrxp2-3-15-1',right:'_1tfbrxp3-3-15-1',both:'_1tfbrxp4-3-15-1'};